import React from 'react'
import "./questionCard.css"
import { Link } from "react-router-dom"


function QuestionCard({ question_data }) {
    return (
        <React.Fragment>
            <Link to={`/editQuestion/${question_data.slug}`} className="block rounded shadow no-underline bg-white">
                <div className="questionCardWrapper p-8 rounded-lg mb-4">
                    <div className="question">
                        <h5 className="mb-0 text-black">{question_data.question}</h5>
                    </div>
                </div>
            </Link>
        </React.Fragment>
    )
}

export default QuestionCard
